function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "save-solid",
  d: "M50.443,43.385l-9.751-9.751A5.58,5.58,0,0,0,36.747,32H5.58A5.58,5.58,0,0,0,0,37.58V78.5a5.58,5.58,0,0,0,5.58,5.58H46.5a5.58,5.58,0,0,0,5.58-5.58V47.33a5.58,5.58,0,0,0-1.634-3.945Zm-24.4,33.253a7.44,7.44,0,1,1,7.44-7.44A7.44,7.44,0,0,1,26.039,76.638ZM37.2,41.239V52.924A1.4,1.4,0,0,1,35.8,54.319H8.835A1.4,1.4,0,0,1,7.44,52.924V40.835A1.4,1.4,0,0,1,8.835,39.44H35.4a1.394,1.394,0,0,1,.986.409l.4.4a1.394,1.394,0,0,1,.409.986Z",
  transform: "translate(0 -25.478)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "ethereum-brands",
  d: "M44.151,31.024,26.081,42.063,8,31.024,26.081,0ZM26.081,45.608,8,34.569,26.081,60.905,44.163,34.569,26.081,45.608Z",
  transform: "translate(95.005)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_1",
  "data-name": "Polygon 1",
  d: "M14.279,2.9a2,2,0,0,1,3.441,0L30.211,23.98A2,2,0,0,1,28.49,27H3.51a2,2,0,0,1-1.721-3.02Z",
  transform: "translate(93.72 16.566) rotate(90)",
  fill: "#fff"
});

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    width: 139.168,
    height: 60.905,
    viewBox: "0 0 139.168 60.905",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.7ac34ec9.svg";
export { ForwardRef as ReactComponent };